import { nanoid } from '../common/nanoidHelper';

export const getUniqueKey = size => nanoid(size);
